import actionTypes from './index';

export default signature => ({
  type: actionTypes.UPDATE_SIGNATURE,
  payload: signature,
});
